import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';

function Stepper({ steps, currentStep }) {
  const { t } = useTranslation('common')

  return (
    <div className="d-flex py-3 align-items-center justify-content-center bg-light">
      {
        steps.map((step, i) => (
          <div key={`${step.name}-${i}`} className="px-3 d-flex align-items-center justify-content-around">
           {currentStep >= i+1 ? 
              <FontAwesomeIcon icon='check-circle' color="green" size="2x" />
            :
             <div className="d-flex rounded-circle bg-grey align-items-center justify-content-center" style={{width: '40px',height: '40px' }}>
              <span>{i + 1}</span>
              </div>
            }
            <span className="ml-2">{t(step.name)}</span>
          </div>
        ))
      }
      
    </div>
  )
}

export default Stepper;
